import LaunchIcon from '@mui/icons-material/Launch';
import { Link as MuiLink } from '@mui/material';
import type { ReactNode } from 'react';

import { useColors } from '../ThemeProvider/useColors';

export interface LinkProps {
  href: string;
  newTab?: boolean;
  children?: ReactNode;
}

export function Link({ href, newTab, children }: LinkProps) {
  const { secondary } = useColors();

  return (
    <MuiLink
      href={href}
      target={newTab ? '_blank' : '_self'}
      rel={newTab ? 'noopener noreferrer' : ''}
      sx={{
        textDecoration: 'none',
        color: secondary,
      }}
    >
      {children}

      {newTab && <LaunchIcon sx={{ fontSize: '1rem', ml: '0.2rem' }} />}
    </MuiLink>
  );
}
